export default "__VITE_ASSET__c2a0fc81__"